import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Confit from "./pages/Config";
import List from "./pages/List";

export const customPages = [
	{ moduleId: "5059a350-8c9a-4fdc-b29f-448ae8147572", path: "list", content: <List /> },
	{ moduleId: "5059a350-8c9a-4fdc-b29f-448ae8147572", path: "config", content: <Confit /> },
] as CustomPage[];
